import { TableModel } from "gaming-component-ngx-common";
import { FormControl } from "@angular/forms";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import "rxjs/Rx";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
    selector: "tableSearch",
     template: `
        <div class="ui icon input">
            <input [formControl]="searchBox" id="searchInput" type="text" [(ngModel)]="tableSearching.searchString">
            <i *ngIf="tableSearching.searchString == ''" class="search icon"></i>
            <span *ngIf="tableSearching.searchString != ''" (click)="tableSearching.searchString = ''" style="position: absolute; top: 45%; right: 10px; cursor: pointer;" id="resetSearchIcon">
                <i class="red remove icon"></i>
            </span>
        </div>
        <label id="searchLabel">{{searchLabel}}</label>
    `,
})

// TODO: This was in use before however it's not available anymore. [ngFormControl]="searchBox"

export class TableSearchComponent {

    @Input() public tableData: TableModel;
    @Input() public searchText: string;
    @Output() public outSearchString: EventEmitter<string> = new EventEmitter();

    // Enables manual refresh from parent component
    @Input() set doRefresh(doRefresh: boolean) {
      if (doRefresh) {
        this.tableData.rows = this.onChangeFilter(this.tableSearching.searchString);
      }
    }

    @Input() public tableSearching: any = {
      columnNames: ["name"],
      searchString: "",
    };

    get searchLabel(): string {
      return `Search for ${this.searchText}`;
    }

    public searchBox: FormControl = new FormControl();

    public constructor() {
      this.searchBox.valueChanges
        .debounceTime(200)
        .distinctUntilChanged()
        .subscribe((event) => this.tableData.rows = this.onChangeFilter(event));
    }

    public onChangeFilter(event: any): Array<any> {
      this.outSearchString.emit(event);
      let result = new Array<any>();

      if (event === '') { // To improve performance on empty search string immediately return all filteredRows
        result = this.tableData.filteredRows;
      } else {
        for (let j = 0; j < this.tableData.filteredRows.length; j++) {
          let rowAdded = false;
          for (let i = 0; i < this.tableSearching.columnNames.length; i++) {
            let searchCol = this.tableSearching.columnNames[i];
            let row = this.tableData.filteredRows[j];
            if (!rowAdded && row[searchCol] &&
            row[searchCol].toLowerCase().indexOf(event.toLowerCase()) >= 0) {
                result.push(row);
                rowAdded = true;
            }
          }
        }
      }

      return result;
    }
}



// WEBPACK FOOTER //
// ./client/app/shared/reportControls/table-searching-component.ts